export const pets = [
  {
    id: 'pet-001',
    name: 'Max',
    photo: 'https://images.unsplash.com/photo-1586671267731-da2cf3ceeb80?w=200',
    species: 'Perro',
    breed: 'Golden Retriever',
    age: 3,
    gender: 'Macho',
    weight: 28.5,
    medicalConditions: 'Ninguna',
    allergies: 'Polen',
    personality: 'Juguetón y amigable',
    specialCare: 'Cepillado diario',
    ownerId: 'owner-001',
    createdAt: '2023-01-15'
  }
];

export const owners = [
  {
    id: 'owner-001',
    name: 'Juan Pérez',
    phone: '+57 3101234567',
    email: 'juan@example.com',
    address: 'Calle 123 #45-67, Bogotá'
  }
];

export const petHistory = [
  {
    id: 'hist-001',
    petId: 'pet-001',
    date: '2023-06-10',
    type: 'service',
    description: 'Baño completo y corte de pelo',
    comments: 'Se comportó muy bien durante el baño',
    caregiver: 'Ana Cuidadora'
  }
];

export const petActivities = [
  {
    id: 'act-001',
    petId: 'pet-001',
    date: '2023-06-15',
    time: '08:00',
    type: 'walk',
    status: 'completed',
    notes: 'Paseo por el parque - 30 min'
  }
];

export const petDocuments = [
  {
    id: 'doc-001',
    petId: 'pet-001',
    name: 'Carnet de vacunación',
    type: 'pdf',
    url: '/docs/vaccines.pdf',
    uploadedAt: '2023-01-20'
  }
];